import { render, staticRenderFns } from "./rolelist.vue?vue&type=template&id=79c4c86f&scoped=true"
import script from "./rolelist.vue?vue&type=script&lang=js"
export * from "./rolelist.vue?vue&type=script&lang=js"
import style0 from "./rolelist.vue?vue&type=style&index=0&id=79c4c86f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4c86f",
  null
  
)

export default component.exports